import React from "react";

function UnlockYourProject() {
  return (
    <>
      <div className="container p-5">
        <div
          className="pricing-style-one-item-cos bg-dark text-light"
          style={{
            backgroundImage:
              "url(https://validthemes.net/site-template/robok/assets/img/shape/10.png)",
          }}
        >
          <div className="text-center">
            <h3>
              Unlock Your Project’s Potential with Xeer Technology’s ICO
              Services
            </h3>
            <div className="bottom">
              <div className="pricing">
                <p>
                  Position your ICO for success with our tailored solutions.
                  Connect with Xeer Technology today to discuss how we can
                  support your token sale and help you achieve your fundraising
                  goals!
                </p>
              </div>
              <a className="btn btn-style-one mt-30" href="#">
                Get Started
              </a>
            </div>
          </div>
          {/* <div className="right-info"></div> */}
        </div>
      </div>
    </>
  );
}

export default UnlockYourProject;
